<!-- Theme CSS -->
<link href="/assets/css/style.css" rel="stylesheet">
<link href="/fr/assets/css/style.css" rel="stylesheet">
<link href="/en/assets/css/style.css" rel="stylesheet">
<link href="/es/assets/css/style.css" rel="stylesheet">
<link href="/pt/assets/css/style.css" rel="stylesheet">
<link href="/ko/assets/css/style.css" rel="stylesheet">
<!-- Navigation -->
<app-sdg-header></app-sdg-header>

<div class="col-sg-12" style="float: right; padding-right: 5px">
<!--   <a href="{{admin_url}}admin/pss_app/teamsummaryview/" target="_blank" class="btn-sg btn btn-info btn-radius" style="margin: 15px 0; min-width: 150px;" i18n>Modify Summary View</a> -->
  <a (click) = "generatePDF()" class="btn-sg btn btn-primary btn-radius" style="margin: 15px 0; min-width: 150px" i18n>Generate PDF</a>
</div>
<div  *ngIf="summaryColumns$ | async as summaryColumns" style="width: 100% ;overflow-y: auto;">
  <section class="content-section" style="padding-top: 0px">
    <table id="summaryTable" class="table table-bordered" style=" border-collapse: separate; border: none; ">
      <thead>
        <!-- Components -->
        <tr class="row-name ">
          <ng-container *ngFor="let component of columnHeading; let i = index">
            <th class="border-none" *ngIf="i !== 1" ></th>
            <th [attr.colspan]="summaryData[component].span" style="font-size:20px;">{{doTranslate(component)}}</th>
          </ng-container>
          <th class="border-none"></th>
        </tr>
      </thead>
      <tbody>
        <!-- Sub Components -->
        <tr>
          <ng-container *ngFor="let component of columnHeading; let i = index">
            <td class="border-none" *ngIf="i !== 1" ></td>
            <ng-container *ngFor="let subComponent of objectKeys(summaryData[component].subComponents)">
              <td class="border-none">
                <span *ngIf="i >= 2">{{doTranslate(subComponent)}}</span>
                <!--<span *ngIf="i >= 3">{{subComponent}}</span>-->
              </td>
            </ng-container>
          </ng-container>
        </tr>
        <ng-container *ngFor="let target of rowHeadings">
          <ng-container *ngFor="let indicator of target.indicator; let i = index">
            <!-- Results -->
            <tr>
              <!-- Water-related SDG Targets -->
              <td class="border-none"></td>
              <td class="blue" *ngIf="i == 0" [attr.rowspan]="target.indicator.length">{{target.label_id}}</td>
              <td *ngIf="i == 0" [attr.rowspan]="target.indicator.length" style="min-width: 300px;align:left;">{lang, plural, =2 {{{target.name_fr}}} =3 {{{target.name_es}}} =4 {{{target.name_pt}}} =5 {{{target.name_ko}}} =6 {{{target.name_ar}}} other {{{target.name}}} }</td>
              <td class="blue" >{{indicator.label_id}}</td>
              <td style="min-width: 300px;align:left;">{lang, plural, =2 {{{indicator.name_fr}}} =3 {{{indicator.name_es}}} =4 {{{indicator.name_pt}}} =5 {{{indicator.name_ko}}} =6 {{{indicator.name_ar}}} other {{{indicator.name}}} }</td>
              <!-- Dynamic results -->
              <ng-container *ngFor="let component of columnHeading; let i = index">
                <ng-container *ngIf="i >= 2">
                  <td class="border-none" *ngIf="i !== 1" ></td>
                  <ng-container *ngFor="let subComponent of objectKeys(summaryData[component].subComponents)">
                    <td class="{{summaryData[component].subComponents[subComponent][indicator.label_id].class}}" style="min-width: 170px;">
                      {{summaryData[component].subComponents[subComponent][indicator.label_id].result}}
                    </td>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </section>
</div>



// WEBPACK FOOTER //
// ./src/app/view-summary/view-summary.component.html